const ConnectionLine = ({ fromX, fromY, toX, toY }) => {
  const gradientId = `edge-gradient`;
  return (
    <g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="100%" stopColor="#6366f1" />
        </linearGradient>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <marker
          id="arrowhead"
          markerWidth="10"
          markerHeight="10"
          refX="8"
          refY="5"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path
            d="M0,2 L10,5 L0,8 Q2,5 0,2"
            fill="#6366f1"
            filter="url(#glow)"
          />
        </marker>
      </defs>
      <path
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={3.5}
        className="animated"
        filter="url(#glow)"
        d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`}
        markerEnd="url(#arrowhead)"
        style={{ transition: 'stroke 0.3s' }}
      />
    </g>
  );
};

export default ConnectionLine;
